import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { tap, catchError, finalize } from 'rxjs/operators';
import { IBuyedpackage } from '../models';
import { StorageService } from './storage.service';
import { API_ENDPOINTS } from '../constants/environment';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TreatmentService {
  private storage = inject(StorageService);
  private http = inject(HttpClient);

  private treatmentSubject = new BehaviorSubject<IBuyedpackage | null>(null);
  public treatment$ = this.treatmentSubject.asObservable();

  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  constructor() {
    this.loadTreatmentFromStorage();
    this.refetchTreatmentOnInit();
  }

  private loadTreatmentFromStorage(): void {
    const treatment = this.storage.getTreatment();
    if (treatment) {
      // if (treatment.healthcareprovider) {
      //   treatment.healthcareprovider.verified = false;
      // }
      this.treatmentSubject.next(treatment);
    }
  }

  fetchTreatmentByHash(hash: string): Observable<IBuyedpackage> {
    this.loadingSubject.next(true);

    const url = `${environment.basePath}/${environment.apiProvider}${API_ENDPOINTS.TREATMENT}`;

    return this.http.get<IBuyedpackage>(url, {
      params: { hash }
    }).pipe(
      tap(treatment => {
       /*  if (treatment?.healthcareprovider) {
          treatment.healthcareprovider.verified = true;
        } */
        this.storage.setTreatment(treatment);
        this.storage.setHash(hash);
        this.treatmentSubject.next(treatment);
        this.loadingSubject.next(false);
      }),
      catchError(error => {
        this.loadingSubject.next(false);
        return throwError(() => error);
      })
    );
  }

  private refetchTreatmentOnInit(): void {
    const hash = this.storage.getHash();
    if (hash) {
      this.fetchTreatmentByHash(hash).subscribe({
        next: () => {
          console.log('Treatment data refreshed successfully');
        },
        error: (error) => {
          console.error('Failed to refresh treatment data:', error);
        }
      });
    }
  }

  getCurrentTreatment(): IBuyedpackage | null {
    return this.treatmentSubject.value;
  }

  updateTreatment(treatment: IBuyedpackage): void {
    this.storage.setTreatment(treatment);
    this.treatmentSubject.next(treatment);
  }

  clearTreatment(): void {
    this.storage.clearTreatment();
    this.treatmentSubject.next(null);
  }

  submitRating(rating: number, comment: string): Observable<any> {
    const treatment = this.getCurrentTreatment();
    if (!treatment) {
      return throwError(() => new Error('No treatment found'));
    }

    const url = `${environment.basePath}/${environment.apiProvider}${API_ENDPOINTS.RATING}`;

    return this.http.post(url, {
      rating,
      message: comment || null
    });
  }

  updateLog(status: string): Observable<any> {
    const treatment = this.getCurrentTreatment();
    if (!treatment) {
      return throwError(() => new Error('No treatment found'));
    }
    this.loadingSubject.next(true);

    const url = `${environment.basePath}/${environment.apiProvider}${API_ENDPOINTS.LOG}`;

    return this.http.post(url, {
      status
    }).pipe(
      tap((response: any) => {
        if (response) {
          const updatedTreatment = {
            ...treatment,
            last_log: response,
            logs: [response, ...(treatment.logs || [])]
          };
          this.updateTreatment(updatedTreatment);
        }
      })
      ,
       finalize(() => this.loadingSubject.next(false))
    );
  }
}
